module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0150.jpg?v=ece5e14e";